/* パスワード */
import React, { useState, memo } from 'react';
import { FormControl, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from '../atoms/Paragraph';
import { mask_string } from '../Const';
var Password = function (_a) {
    var id = _a.id, fm_id = _a.fm_id, label = _a.label, need = _a.need, value = _a.value, placeholder = _a.placeholder, handleChange = _a.handleChange, message = _a.message, name = _a.name, help_msg = _a.help_msg, disabled = _a.disabled, maxlength = _a.maxlength, handleBlur = _a.handleBlur, handleFocus = _a.handleFocus, visible_type = _a.visible_type;
    // input type
    var _b = useState('password'), type = _b[0], setType = _b[1];
    // パスワードの表示
    var _c = useState(false), is_visible = _c[0], setIsVisible = _c[1];
    /**
     * パスワードを表示
     */
    var handleChangeVisible = function () {
        var visible = !is_visible;
        if (visible) {
            setType(visible_type);
        }
        else {
            setType('password');
        }
        setIsVisible(visible);
    };
    /**
     * Changeイベント
     * @returns void
     */
    var handleChangeInput = function (event) {
        var max_length = typeof maxlength !== 'undefined' ? maxlength : 0;
        if (is_visible && event.target.value.length > max_length) {
            return;
        }
        handleChange(event);
    };
    /**
     * max値の設定
     * @returns max値の文字列
     */
    var max = function () {
        var max = '';
        var max_length = typeof maxlength !== 'undefined' ? maxlength : 0;
        for (var i = 0; i < max_length; i++) {
            max += '9';
        }
        return max;
    };
    var returnTextFormJsx = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "password row" },
                React.createElement("div", { className: "col-12 col-sm-6 col-md-8" },
                    React.createElement(FormControl, { id: id, "data-fm_id": fm_id, type: type, value: value, onChange: handleChangeInput, placeholder: placeholder, name: name, disabled: disabled, onBlur: handleBlur, onFocus: handleFocus, maxLength: maxlength, min: "0", max: max() })),
                React.createElement("div", { className: "col-12 col-sm-6 col-md-4" },
                    React.createElement("label", null,
                        React.createElement("input", { type: "checkbox", defaultChecked: is_visible, onChange: handleChangeVisible }),
                        label,
                        "\u3092\u8868\u793A"))),
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message })));
    };
    var returnLabelJsx = function () {
        // マスク文字列
        var masked_value = ''; // 初期化
        for (var i = 0; i < value.length; i++) {
            masked_value += mask_string;
        }
        return (React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(Paragraph, { label: masked_value }))));
    };
    return (React.createElement(RowTemplate, { label: label, need: need, disabled: disabled, content: disabled ? returnLabelJsx() : returnTextFormJsx() }));
};
export default memo(Password);
